


<template>
   
      <div class="py-1 ">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header pb-0">
              <div class="align-items-center text-center mb-4">
                   <img :src="iconSubmisstion" class="img-full-width"/>
              </div>
              <div class="align-items-center">
                <p class="mb-0 text-lg text-center text-black">
                   {{ currentMessages.InvoiceTitleSubmission }} </p>
                <p class="mb-0 text-md text-center text-black">
                  {{ currentMessages.TitlRequesteStutusComplete }} 
                </p>

                  <p class="mb-0 text-sm text-center text-black">
                  {{ currentMessages.TitlRequesteReceiptNo }} : {{ receiptStore.receiptsCode }}
                </p>

                  <p class="mb-0 text-sm text-center text-black">
                  {{ currentMessages.TitlRequesteStoreNo }} : {{ receiptStore.storeNumber }}
                </p>
              </div>
            </div>
            <div class="card-body mt-1">
              
            <div class="row mb-5">
              <div class="col-md-6 mx-auto text-center">
                <GlobalButtonNext @click="handleClickCreateRequestForm">
                  {{ currentMessages.ButtonNewRequest }}
                  <i class="fa fa-plus-circle" aria-hidden="true" style="font-size: 18px; margin-left:5px;"></i>
                </GlobalButtonNext>
              </div>
            </div>


             
               
            </div>
          </div>
        </div>
        <div class="col-md-4 mb-5">
        </div>
      </div>
    </div>

     
    

</template>







<script setup>

import GlobalButtonNext from "@/components/global/GlobalButtonPrimary.vue";
//import { useRouter } from 'vue-router' 
import { useReceiptStoreEtax } from '@/store/useReceiptStoreEtax';
import iconSubmisstion from '@/assets/img/icons/pages/icon_submission.svg';
import { onMounted, computed } from "vue";
import { useStore } from "vuex";
//language // 
import messages from '@/locales/messages';
import { useLanguageStore } from '@/store/useLanguageStore';
const languageStore = useLanguageStore();
const currentMessages = computed(() => messages[languageStore.selectedLanguage]);
//End language // 

//const emit = defineEmits(['prev']);
const receiptStore = useReceiptStoreEtax();
const handleClickCreateRequestForm = () => {
    window.location.reload();
};


const store = useStore();

onMounted(() => {
  store.state.isAbsolute = true;

});


//const receiptStore = useReceiptStore();

</script>
